var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectIconRedWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0009 8.01562C15.625 8.01562 8.01562 15.625 8.01562 25.0009C8.01562 34.3768 15.625 41.9862 25.0009 41.9862C34.3768 41.9862 41.9861 34.3769 41.9861 25.001C41.9861 15.6251 34.3768 8.01562 25.0009 8.01562ZM11.4127 25.0009C11.4121 23.2163 11.7632 21.4491 12.4459 19.8003C13.1286 18.1514 14.1295 16.6532 15.3914 15.3914C16.6532 14.1295 18.1514 13.1286 19.8003 12.4459C21.4491 11.7632 23.2163 11.4121 25.0009 11.4127C28.019 11.4066 30.9511 12.4179 33.3237 14.2832L14.2832 33.3237C12.4179 30.9511 11.4066 28.019 11.4127 25.0009ZM25.0009 38.5892C21.9827 38.5953 19.0505 37.5841 16.6777 35.7187L35.7187 16.6777C37.584 19.0504 38.5952 21.9824 38.5892 25.0005C38.5898 26.7851 38.2387 28.5524 37.5561 30.2013C36.8734 31.8502 35.8725 33.3484 34.6106 34.6104C33.3487 35.8723 31.8505 36.8732 30.2016 37.5559C28.5528 38.2386 26.7855 38.5897 25.0009 38.5892Z",
    fill: "#BB5353"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIconRedWithWhiteCircle);
export default __webpack_public_path__ + "static/media/reject_icon_red_with_white_circle.afb24e58d8b4070e47b20ee44869aa6d.svg";
export { ForwardRef as ReactComponent };